export const EMAIL_CHALLENGE_PROVIDER = "email-challenge-provider";
export const EMAIL_CHALLENGE_CODE_LENGTH = 6;
